module.exports = __webpack_public_path__ + "static/media/7.9387d9e4.jpg";